<script>
  import { Carousel } from "./widget";
  import Content from "./BannerContent.svelte";
</script>

<style>
  div {
    position: relative;
    display: flex;
  }
  div.img-container {
    z-index: -1;
    flex: 1 1 0px;
  }

  picture {
    width: 100%;
    max-height: 720px;
  }

  img {
    width: 100%;
    max-height: 720px;
    min-height: 280px;
  }

  @media screen and (min-width: 600px) and (max-width: 1280px) {
    img {
      max-height: unset;
    }
    picture {
      max-height: unset;
    }
  }

  @media screen and (max-width: 600px) {
    img {
      height: 500px;
      max-height: unset;
    }
    picture {
      max-height: unset;
    }
  }
</style>

<div>
  <Carousel perPage={1} autoplay={15000}>
    <i slot="left-control" class="fa fa-angle-left" />
    <i slot="right-control" class="fa fa-angle-right" />

    <div class="img-container slide-content">
      <picture>
        <source
          srcset="images/banner/[1x]-banner0.jpg"
          media="(min-width: 600px)" />
        <source
          srcset="images/banner/[small]-banner0.jpg"
          media="(max-width: 600px)" />
        <img src="images/banner/[1x]-banner0.jpg" alt="banner" />
      </picture>
    </div>
    <div class="img-container slide-content">
      <picture>
        <source
          srcset="images/banner/[1x]-banner1.png"
          media="(min-width: 600px)" />
        <source
          srcset="images/banner/[small]-banner1.jpg"
          media="(max-width: 600px)" />
        <img src="images/banner/[1x]-banner1.png" alt="banner" />
      </picture>
    </div>
    <div class="img-container slide-content">
      <picture>
        <source
          srcset="images/banner/[1x]-banner6.png"
          media="(min-width: 600px)" />
        <source
          srcset="images/banner/[small]-banner6.jpg"
          media="(max-width: 600px)" />
        <img src="images/banner/[1x]-banner6.png" alt="banner" />
      </picture>

    </div>
    <div class="img-container slide-content">
      <picture>
        <source
          srcset="images/banner/[1x]-banner2.png"
          media="(min-width: 600px)" />
        <source
          srcset="images/banner/[small]-banner2.jpg"
          media="(max-width: 600px)" />
        <img src="images/banner/[1x]-banner2.png" alt="banner" />
      </picture>
    </div>

    <div class="img-container slide-content">
      <picture>
        <source
          srcset="images/banner/[1x]-banner11.png"
          media="(min-width: 600px)" />
        <source
          srcset="images/banner/[small]-banner11.jpg"
          media="(max-width: 600px)" />
        <img src="images/banner/[1x]-banner11.png" alt="banner" />
      </picture>
    </div>
  </Carousel>
  <Content />
</div>
